<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {ref} from "vue";
import useValidation from "@/use/Validation";
import {useWorkerBalanceStore} from "@/stores/WorkerBalance";
import axios from "axios";

export default {
    name: "AddManualForm",
    props: {
        produce: Boolean,
        consume: Boolean,
    },
    setup(props) {
        const {loading, dialog} = useSharedData();
        const {getBack} = useSharedMethod();
        const {$refs, $route} = useTools();
        const {mxRules} = useValidation();
        const workerBalanceStore = useWorkerBalanceStore();

        const inOut = ref({
            direction: props.produce ? 'IN' : 'OUT'
        });

        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                let path = `/workerBalances/manual_produce_and_consume/${$route.params.id}`;
                axios.post(path, inOut.value).then(response => {
                    workerBalanceStore.updateWorkerBalance(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            mxRules,
            dialog,
            loading,
            inOut,
            workerBalanceStore,
            getBack,
            save,
        }
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="600"
        scrollable
    >
        <v-card>
            <w-toolbar
                v-if="produce"
                color="teal"
                :title="`Alimenter ${workerBalanceStore.workerBalance.balanceName} [${workerBalanceStore.workerBalance.workerName}]`"
            />
            <w-toolbar
                v-if="consume"
                color="red"
                :title="`Consumer ${workerBalanceStore.workerBalance.balanceName} [${workerBalanceStore.workerBalance.workerName}]`"
            />
            <v-card-text>
                <v-form ref="form" lazy-validation>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12" v-if="$route.params.byDate">
                                <w-label :label="$t('common.date')" required/>
                                <w-date-picker
                                    v-model="inOut.date"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12" v-else>
                                <w-label :label="$t('common.month')" required/>
                                <w-month-picker
                                    v-model="inOut.month"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.value')" required/>
                                <w-text-field
                                    v-model="inOut.value"
                                    type="number"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.comment')" required/>
                                <w-simple-text-area
                                    v-model="inOut.observation"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn
                    v-if="produce"
                    color="teal"
                    icon="mdi-plus-circle-outline"
                    :text="$t('balance.manual_produce')"
                    :loading="loading"
                    @press="save"
                />
                <w-btn
                    v-if="consume"
                    color="red"
                    icon="mdi-minus-circle-outline"
                    :text="$t('balance.manual_consume')"
                    :loading="loading"
                    @press="save"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>